import { useState, useEffect, useRef, useContext } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import { useNavigate, useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import { Modal, Radio } from 'antd';

import moment from 'moment';    

import NumberFormat from "react-number-format";
import {UserContext} from "../../App"
import UserAlerts from "../../components/UserAlerts";
// import DashboardHeader from "../../components/DashboardHeader";

import './Rentals.css'


function ManagementContractEdit({managementContract, isModalOpen, setIsModalOpen}) {

    // const {response, error, fetchData}  = useAxios();
    const [error, setError] = useState('');
    const errorRef = useRef(null);


    const queryClient = useQueryClient();

    const page_size = useContext(UserContext).page_size;

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // const navigate = useNavigate();
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    // const [city, setCity] = useState('');
    const [feeStructure, setFeeStructure] = useState('');
    const [feePercentage, setFeePercentage] = useState('');
    const [feeAmount, setFeeAmount] = useState('');
    const [managementFee, setManagementFee] = useState('');
    const [effectiveDate, setEffectiveDate] = useState('');
    const [eventType, setEventType] = useState('');


    const [nameError, setNameError] = useState(false)
    const [addressError, setAddressError] = useState(false);
    const [cityError, setCityError] = useState(false);

    const mcEvents = [
        { name: "Fee Change", value: "020" },
        { name: "Cancellation", value: "090" },
    ];


    const contactRef = useRef("");
    contactRef.showContactType=true    


    const mutation = useMutation({
        mutationFn: (managementContract) => {
            // return authAxios.post("/rentals/properties/", property);
            return authAxios.put(`rentals/properties/${managementContract.id}/`, managementContract);

        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['properties', 'property']);
            // navigate('/dashboard/properties/')
            queryClient.refetchQueries(['properties']);
            queryClient.refetchQueries(['property']);
            setIsModalOpen(false)
        },
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        if (name === '') {
            setNameError(true)
        }

        if (name) {

            // const landlord = owner.id

            const management_fee = managementFee? parseFloat(managementFee) / 100 : null;

            // const property = { type, client, name, address, city, country, email, trust_account, control_account, user, memo, landlord };
            const propertyData = {name, management_fee };

            console.log(propertyData)
            mutation.mutate(propertyData)
            
        } 
    
    }

    useEffect(()=>{   
        if (managementContract){
            setFeeStructure(managementContract.fee_structure)
            setFeePercentage(managementContract.fee_percentage*100)
            setFeeAmount(managementContract.fee_amount)
            // setName(property.name);
            // setAddress(property.address)
            // setCity(property.city)
            // setManagementFee(parseFloat(property.management_fee) * 100)

        }
    },[managementContract])

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])


    return(
        <>
        {isModalOpen && 
            <Modal className="dashboard-modal" title="Amend Management Contract" visible={isModalOpen} open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <TextField className="custom-input"
                            value={managementContract.property_name || ''}
                            label="Property" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />

                        <TextField className="custom-input"
                            value={managementContract.owner || ''}
                            label="Owner" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />

                        <Autocomplete
                            // value={owner}
                            onChange={(event, newValue) => {
                                setEventType(newValue);
                                console.log("VALUE", newValue)
                                }}
                            options={mcEvents}
                            getOptionLabel={(option) => option?.name || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Amendment Type"  /> }
                        />

                        

                        <Radio.Group 
                            onChange={(e)=>setFeeStructure(e.target.value)} 
                            className="custom-input"
                            value={feeStructure}
                        >
                            <Radio value="020">Percentage</Radio>
                            <Radio value="010">Flat</Radio>
                        </Radio.Group>


                        {feeStructure === "020" &&
                        <NumberFormat 
                            value={feePercentage}
                            onChange={(e) => setFeePercentage(e.target.value)}
                            className="custom-input"
                            fullWidth
                            label="Management Fee Percent" 
                            variant="outlined" 
                            customInput={TextField}
                            suffix="%"
                            decimalScale={2}
                            fixedDecimalScale
                            decimalSeparator="."
                            allowNegative={false}
                            isNumericString
                        />}
                        {feeStructure === "010" &&
                        <NumberFormat   
                            value={feeAmount}
                            onChange={(e) => setFeeAmount(e.target.value)}
                            className="custom-input"
                            fullWidth
                            label="Management Fee Amount" 
                            variant="outlined" 
                            customInput={TextField}
                            suffix=""
                            decimalScale={2}
                            fixedDecimalScale
                            decimalSeparator="."
                            allowNegative={false}
                            isNumericString
                        />}



                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopDatePicker
                                value={effectiveDate}
                                label="Effective Date"
                                inputFormat="DD-MM-YYYY" 
                                onChange={(newDate) => {
                                    setEffectiveDate(moment(newDate).format("YYYY-MM-DD"));
                                }}
                                // error={!effectiveDate}
                                // helperText={!effectiveDate ? "Effective date is required" : ""} 
                                renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                            />
                        </LocalizationProvider>

                    </form>
                </div>
            </Modal>
        }
        </>

    )
}

export default ManagementContractEdit;
